import React from "react";
import ProviderListing from "./ProviderListing";

import { Listing } from "./types";

function NoResults() {
  return (
    <div style={{ fontWeight: 600 }} data-testid="results-no-listings">
      We couldn't find any optometrists in this area
    </div>
  );
}
function Listings({ listings }: { listings: Array<Listing> }) {
  return (
    <ul data-testid="results-listings-list">
      {listings.map((listing) => (
        <ProviderListing key={listing.id} {...listing} />
      ))}
    </ul>
  );
}

function ProviderListings({ listings }: { listings: Array<Listing> }) {
  let Results;
  if (!listings.length) {
    Results = <NoResults />;
  } else {
    Results = <Listings listings={listings} />;
  }

  return <>{Results}</>;
}

export default ProviderListings;
